/* eslint-disable no-console */
/* eslint-disable no-plusplus */
/* eslint-disable camelcase */

import isEmpty from 'lodash.isempty';
import { applySnapshot, flow, getRoot, getSnapshot } from 'mobx-state-tree';

import { logger } from '@lusha/client-logger';

import { searchCompaniesByName } from '../../../API/prospectingAPI';
import { formatFundingSummary } from '../FundingSummary/utils';

import { getRevenueRangeString } from './utils';
const Actions = self => {
  let initialState;

  const resetState = () => {
    applySnapshot(self, initialState);
  };

  return {
    afterCreate: () => {
      initialState = getSnapshot(self);
    },
    setCompany: company => {
      if (isEmpty(company)) {
        resetState();

        return;
      }

      const {
        name = '',
        logo_url = '',
        domains: { homepage = '' } = {},
        homepage_url = '',
        location: { city, region, country = '', country_iso2 = '', state = '' } = {},
        company_size: { min, max } = {},
        description = '',
        founded,
        industry_tags = [],
        social: { facebook, twitter, LinkedIn, linkedin } = {
          facebook: '',
          twitter: '',
          LinkedIn: '',
          linkedin: '',
        },
        revenue_range,
        company_lid: companyLid = null,
        company_lids: companyLids,
        isBlockedForShow,
        topics = [],
        funding_summary: fundingSummary = null,
        industry = {},
        specialities,
        metadata,
      } = company;

      const { primary_industry: primaryIndustry = {} } = industry;

      self.hasCompany = true;
      self.isSocial = !!company.social;
      self.name = name || '';
      self.logoUrl = logo_url || '';
      self.domain = homepage || 'Company Website';
      self.homepageUrl = homepage_url || '';
      self.city = city || '';
      self.region = region || '';
      self.country = country || '';
      self.country_iso2 = country_iso2;
      self.state = state;
      self.min = min || 0;
      self.max = max || 0;
      self.about = description || '';
      self.founded = founded || '';
      self.specialities = specialities || industry_tags || [];
      self.mainIndustry = industry?.primary_industry?.key || '';
      self.mainIndustryKey = primaryIndustry.key || '';
      self.subIndustry = primaryIndustry?.sub_industry?.key || '';
      self.facebook = facebook || '';
      self.twitter = twitter || '';
      self.LinkedIn = LinkedIn || linkedin || '';
      self.companyResultString = JSON.stringify(company);
      self.revenueRange = revenue_range ? { ...revenue_range, string: getRevenueRangeString(revenue_range) } : {};
      self.companyLid = companyLid;
      self.companyLids = companyLids;
      self.isBlockedForShow = isBlockedForShow || false;
      self.lushaCompanyId = company.lusha_company_id;
      if (self.topics.length === 0) {
        self.topics = topics;
      }
      self.fundingSummary = formatFundingSummary(fundingSummary);
      self.mainIndustryId = industry?.primary_industry?.id;
      if (metadata) {
        self.metadata = {
          hasProspectingContacts: metadata.has_prospecting_contacts ?? null,
          hasProspectingContactsCount: metadata.has_prospecting_contacts_count ?? null,
          companyScore: metadata.company_score ?? null,
          partialCompany: metadata.partial_company ?? null,
        };
      }
    },
    setListId(listId) {
      self.listId = listId;
    },
    setCompanyLid(companyLid) {
      self.companyLid = companyLid;
    },
    fetchCompanyLid: flow(function* fetchCompanyLid() {
      const { context } = getRoot(self);

      try {
        const response = yield searchCompaniesByName({
          company: self.name,
          platform: 'Scout',
          url: context.url,
        });
        if (response.companies?.length) {
          const searchedCompany = response.companies[0];
          const companyLid = searchedCompany.company_lid;
          self.setCompanyLid(companyLid);
        }
      } catch (error) {
        logger.info('Failed to fetch company lid: ', error);
      }
    }),
    setPartial: company => {
      self.name = company.name || '';
      self.domain = company.domain || '';
      self.logoUrl = company.logoUrl || '';
    },
  };
};

export default Actions;
